<div class="landing-merchants-wrapper">
  <div class="landing-merchants-content-wrapper">
    <div class="landing-merchants-content">
      <h2 class="landing-merchants-header">{{ 'have_shops' | translate }}</h2>
      <a [attr.href]="zohoUrl" target="_blank" rel="noopener noreferrer" class="landing-merchants-link">
        <figure class="landing-merchants-link-figure">
          <img
            src="/assets/images/landing/merchants/landing-merchants-link-icon.svg"
            alt="Landing merchants link icon"
            loading="lazy"
          />
        </figure>
        <span>{{ 'join_team' | translate }}</span>
      </a>
    </div>
  </div>
</div>
